import React, { useEffect, useState } from 'react';

interface Sakura {
  id: number;
  x: number;
  y: number;
  size: number;
  speed: number;
  rotation: number;
  rotationSpeed: number;
  opacity: number;
}

export default function SakuraAnimation() {
  const [sakuras, setSakuras] = useState<Sakura[]>([]);

  useEffect(() => {
    // Buat sakura petals
    const createSakuras = () => {
      const newSakuras: Sakura[] = [];
      for (let i = 0; i < 15; i++) {
        newSakuras.push({
          id: i,
          x: Math.random() * window.innerWidth,
          y: -10,
          size: Math.random() * 8 + 4,
          speed: Math.random() * 2 + 1,
          rotation: 0,
          rotationSpeed: Math.random() * 4 - 2,
          opacity: Math.random() * 0.6 + 0.4
        });
      }
      setSakuras(newSakuras);
    };

    createSakuras();

    // Animasi sakura
    const animateSakuras = () => {
      setSakuras(prev => prev.map(sakura => ({
        ...sakura,
        y: sakura.y + sakura.speed,
        x: sakura.x + Math.sin(sakura.y * 0.01) * 0.5,
        rotation: sakura.rotation + sakura.rotationSpeed,
        // Reset posisi ketika sakura keluar dari layar
        ...(sakura.y > window.innerHeight + 20 ? {
          y: -10,
          x: Math.random() * window.innerWidth
        } : {})
      })));
    };

    const interval = setInterval(animateSakuras, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-10 overflow-hidden">
      {sakuras.map(sakura => (
        <div
          key={sakura.id}
          className="absolute text-pink-300"
          style={{
            left: `${sakura.x}px`,
            top: `${sakura.y}px`,
            fontSize: `${sakura.size}px`,
            opacity: sakura.opacity,
            transform: `rotate(${sakura.rotation}deg)`,
            transition: 'none'
          }}
        >
          🌸
        </div>
      ))}
    </div>
  );
}